import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../api/api";
import "../styles/footer.css";

export default function Footer() {
  const [ngo, setNgo] = useState({});

  useEffect(() => {
    const fetchNgo = async () => {
      try {
        const res = await api.get("/core/");
        const data = Array.isArray(res.data) ? res.data[0] : res.data;

        if (data) {
          setNgo(data);
        }
      } catch (error) {
        console.error("Footer API Error:", error);
      }
    };

    fetchNgo();
  }, []);

  return (
    <footer className="footer">

      <div className="footer-top">

        {/* NGO NAME */}
        <h3 className="footer-title">
          {ngo.name || "Shri Ramakrishna Vivekananda Jnana Vikasa Shikshana Samste"}
        </h3>

        {/* ADDRESS */}
        {ngo.address && (
          <p className="footer-item">
            📍{" "}
            <a
              href={`https://maps.google.com/?q=${encodeURIComponent(
                ngo.address
              )}`}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              {ngo.address}
            </a>
          </p>
        )}

        {/* CONTACT */}
        {(ngo.phone || ngo.email) && (
          <p className="footer-item">

            {ngo.phone && (
              <>
                📞{" "}
                <a href={`tel:${ngo.phone}`} className="footer-link">
                  {ngo.phone}
                </a>
              </>
            )}

            {ngo.phone && ngo.email && " | "}

            {ngo.email && (
              <>
                ✉️{" "}
                <a href={`mailto:${ngo.email}`} className="footer-link">
                  {ngo.email}
                </a>
              </>
            )}

          </p>
        )}

        {/* MAP LINK */}
        {ngo.map_link && (
          <p className="footer-item">
            🗺{" "}
            <a
              href={ngo.map_link}
              target="_blank"
              rel="noopener noreferrer"
              className="footer-link"
            >
              View on Google Maps
            </a>
          </p>
        )}

        {/* ABOUT LINK */}
        <p className="footer-item">
          <Link to="/about" className="footer-link">
            About Us
          </Link>
        </p>

      </div>

      {/* FOOTER COPYRIGHT */}
      <div className="footer-bottom">
        © {new Date().getFullYear()} {ngo.name || "Shri Ramakrishna Vivekananda Jnana Vikasa Shikshana Samste"}. All rights reserved.
      </div>

    </footer>
  );
}